import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Alert } from 'antd';
import { UserOutlined, LockOutlined, BankOutlined } from '@ant-design/icons';
import api from '../api';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/login', {
        phone: values.phone,
        password: values.password,
      });
      localStorage.setItem('token', res.token);
      localStorage.setItem('user', JSON.stringify(res.user));
      navigate('/');
    } catch (err) {
      setError(err.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#fff' }}>
      <div style={{
        background: 'linear-gradient(180deg, #1677FF 0%, #4096ff 100%)',
        padding: '60px 0 80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
      }}>
        <div style={{
          width: 64,
          height: 64,
          borderRadius: 16,
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}>
          <BankOutlined style={{ fontSize: 32, color: '#1677FF' }} />
        </div>
        <div style={{ color: '#fff', fontSize: 24, fontWeight: 700 }}>云仓智管</div>
      </div>

      <div style={{
        flex: 1,
        background: '#fff',
        borderRadius: '24px 24px 0 0',
        marginTop: -40,
        padding: '32px 24px 0',
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}>
        <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>欢迎登录</div>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            onClose={() => setError('')}
            style={{ marginBottom: 16 }}
          />
        )}

        <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
          <Form.Item
            label="手机号"
            name="phone"
            rules={[
              { required: true, message: '请输入手机号' },
              { pattern: /^\d{11}$/, message: '请输入11位数字手机号' },
            ]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#bbb' }} />}
              placeholder="11位数字手机号"
              size="large"
              maxLength={11}
              inputMode="numeric"
            />
          </Form.Item>
          <Form.Item label="密码" name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: '#bbb' }} />}
              placeholder="请输入密码"
              size="large"
            />
          </Form.Item>
          <Form.Item style={{ marginTop: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 44, borderRadius: 8, fontSize: 16, fontWeight: 500 }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ flex: 1 }} />
        <div style={{ textAlign: 'center', color: '#ccc', fontSize: 12, padding: '16px 0' }}>
          © 2026 大检站执勤三队
        </div>
      </div>
    </div>
  );
}
